<template>
  <div class="storenotecardstyle">
    <!-- 标题 -->
    <h2>{{ datas.text }}</h2>

    <!-- 表单 -->
    <el-form label-width="80px" :model="datas" size="small" :rules="rules">
      <el-form-item :label="$t('app.name')" class="lef">
        <el-input v-model="datas.name"></el-input>
      </el-form-item>

      <div class="bor" />

      <!-- 标题内容 -->
      <el-form-item class="lef" :label="$t('app.label')">
        <p style="color: #000">{{ styleText }}</p>
      </el-form-item>

      <!-- 卡片样式选择 -->
      <div class="commodityType">
        <el-tooltip
          class="item"
          effect="dark"
          :content="item.content"
          placement="bottom"
          v-for="(item, index) in commodityTypes"
          :key="index"
        >
          <span
            class="iconfont"
            style="font-size: 21px"
            :class="[
              item.type === datas.commodityType ? 'active' : '',
              item.icon,
            ]"
            @click="datas.commodityType = index"
          />
        </el-tooltip>
      </div>

      <div class="bor" />

      <h5 style="color: #000; font-size: 14px">{{ $t('app.auto_317_2b0717ec') }}</h5>
      <p style="color: #969799; font-size: 12px; margin-top: 10px">{{ $t('app.auto_318_0d696691') }}</p>

      <!-- 图片广告 -->
      <div v-if="datas.imageList[0]">
        <vuedraggable v-model="datas.imageList" v-bind="dragOptions">
          <transition-group>
            <section
              class="imgBanner"
              v-for="(item, index) in datas.imageList"
              :key="item + index"
            >
              <i class="el-icon-circle-close" @click="deleteimg(index)" />
              <!-- 图片 -->
              <div class="imag">
                <img :src="item.src" alt="" draggable="false" />
              </div>
              <!-- 标题和链接 -->
              <div class="imgText">
                <el-input
                  v-model="item.text"
                  :placeholder="$t('app.placeholder')"
                  size="mini"
                />
                <!-- 标题和链接 -->
                <div class="imgTextChild">
                  <!-- 选择类型 -->
                  <el-select
                    v-model="item.linktype"
                    :placeholder="$t('app.pleaseSelect')"
                    size="mini"
                    @change="selectType(index)"
                  >
                    <el-option
                      v-for="iteml in optionsType"
                      :key="iteml.name"
                      :label="iteml.name"
                      :value="iteml.type"
                    >
                    </el-option>
                  </el-select>

                  <!-- 输入外部链接 -->
                  <el-input
                    size="mini"
                    :placeholder="$t('app.pleaseEnter')"
                    v-model="item.http.externalLink"
                  >
                  </el-input>
                </div>
              </div>
            </section>
          </transition-group>
        </vuedraggable>
      </div>

      <!-- 上传图片 -->
      <el-button
        @click="$refs.upload.showUpload()"
        class="uploadImg"
        type="primary"
        plain
        ><i class="el-icon-plus" />{{ $t('app.auto_319_acd760be') }}</el-button
      >

      <div style="height: 10px" />

      <!-- 卡片样式 -->
      <el-form-item :label="$t('app.label')" class="lef" />
      <!-- 卡片样式选择 -->
      <div class="moditystyle">
        <span
          v-for="(item, index) in moditystyles"
          :key="index"
          :class="item.type == datas.moditystyle ? 'active' : ''"
          @click="datas.moditystyle = index"
        >
          {{ item.text }}
        </span>
      </div>

      <div class="bor" />

      <!-- 文本粗细 -->
      <el-form-item
        class="lef"
        :label="$t('app.label')"
        prop="textWeight"
        :hide-required-asterisk="true"
      >
        <el-input
          type="number"
          v-model.number="datas.textWeight"
          :placeholder="$t('app.pleaseEnter')"
        />
      </el-form-item>

      <div style="height: 10px" />

      <!-- 图片倒角 -->
      <el-form-item :label="$t('app.label')" class="lef borrediu">
        <el-slider
          v-model="datas.borderRadius"
          :max="30"
          input-size="mini"
          show-input
        >
        </el-slider>
      </el-form-item>

      <div style="height: 10px" v-if="datas.commodityType === 0" />

      <!-- 显示位置 -->
      <el-form-item
        :label="$t('app.label')"
        class="lef"
        v-if="datas.commodityType === 0"
      >
        <div class="weiz">
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('app.auto_519_9158c62d')"
            placement="bottom"
          >
            <i
              :class="datas.positions === 'top' ? 'active' : ''"
              class="iconfont icon-shang"
              @click="datas.positions = 'top'"
            />
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('app.auto_520_e62cf834')"
            placement="bottom"
          >
            <i
              :class="datas.positions === 'bottom' ? 'active' : ''"
              class="iconfont icon-jiantou"
              @click="datas.positions = 'bottom'"
            />
          </el-tooltip>
        </div>
      </el-form-item>

      <div class="bor" />

      <!--笔记标签 -->
      <el-form-item class="lef" :label="$t('app.label')">
        {{ datas.noteLabels ? this.$t('app.auto_521_03942fb2') : this.$t('app.auto_522_35bd42cb') }}
        <el-checkbox style="margin-left: 196px" v-model="datas.noteLabels" />
      </el-form-item>

      <!--阅读数 -->
      <el-form-item class="lef" :label="$t('app.label')">
        {{ datas.readingNumber ? this.$t('app.auto_523_e85c1c82') : this.$t('app.auto_524_2d5c1fe7') }}
        <el-checkbox style="margin-left: 196px" v-model="datas.readingNumber" />
      </el-form-item>

      <!--点赞数 -->
      <el-form-item class="lef" :label="$t('app.label')">
        {{ datas.praisePoints ? this.$t('app.auto_525_60157788') : this.$t('app.auto_526_0f5d35fe') }}
        <el-checkbox style="margin-left: 196px" v-model="datas.praisePoints" />
      </el-form-item>

      <!--查看更多 -->
      <el-form-item class="lef" :label="$t('app.label')">
        <!-- {{datas.viewMore1 ? this.$t('app.auto_527_2cf835ed') : this.$t('app.auto_528_32dfabf2')}} -->
        <el-checkbox v-model="datas.viewMore1"
          >头部{{ datas.viewMore1 ? this.$t('app.auto_529_32a3367d') : this.$t('app.auto_530_9e8bd9c0') }}</el-checkbox
        >
        <el-checkbox v-model="datas.viewMore2"
          >尾部{{ datas.viewMore2 ? this.$t('app.auto_531_db197713') : this.$t('app.auto_532_b58d720f') }}</el-checkbox
        >
        <div class="imgText1" v-show="datas.viewMore1 || datas.viewMore2">
          <!-- 选择类型 -->
          <el-select
            style="width: 60%"
            v-model="datas.linktype"
            :placeholder="$t('app.pleaseSelect')"
            size="mini"
          >
            <el-option
              v-for="item in optionsType1"
              :key="item.name"
              :label="item.name"
              :value="item.type"
            >
            </el-option>
          </el-select>

          <!-- 输入外部链接 -->
          <el-input
            style="width: 100%"
            size="mini"
            :placeholder="$t('app.pleaseEnter')"
            v-model="datas.http.externalLink"
          >
          </el-input>
        </div>
      </el-form-item>
    </el-form>

    <!-- 上传图片 -->
    <uploadimg ref="upload" @uploadInformation="uploadInformation" />
  </div>
</template>

<script>
import vuedraggable from 'vuedraggable' //拖拽组件
import uploadimg from '../../uploadImg' //图片上传

export default {
  name: 'storenotecardstyle',
  props: {
    datas: Object,
  },
  components: { vuedraggable, uploadimg },
  data() {
    let kon = (rule, value, callback) => {
      if (value.length === 0) callback(new Error(this.$t('salesCenter.pleaseEnterValidNumber')))
    }
    return {
      optionsType1: [
        {
          type: '10',
          name: this.$t('app.auto_533_ff7f57b6'),
        },
        {
          type: '11',
          name: this.$t('app.auto_534_eafaa13f'),
        },
      ], // 选择跳转类型
      options1: [],
      moditystyles: [
        /* 卡片样式 */
        {
          text: this.$t('app.auto_535_45dba234'),
          type: 0,
        },
        {
          text: this.$t('app.auto_536_d8d41d1a'),
          type: 1,
        },
        {
          text: this.$t('app.auto_537_200e510a'),
          type: 2,
        },
        {
          text: this.$t('app.auto_538_3a99fd16'),
          type: 3,
        },
      ],
      commodityTypes: [
        {
          icon: 'icon-datumoshi',
          type: 0,
          content: this.$t('app.auto_539_c06bd7aa'),
        },
        {
          icon: 'icon-commodity-yihangliangge',
          type: 1,
          content: this.$t('app.auto_540_997720bf'),
        },
        {
          icon: 'icon-xuanzemokuai-daohanghengxianghuadong',
          type: 2,
          content: this.$t('app.auto_541_a5a5eb74'),
        },
        {
          icon: 'icon-sanlan',
          type: 3,
          content: this.$t('app.auto_542_3c169032'),
        },
        {
          icon: 'icon-commodity-xiangxiliebiao',
          type: 4,
          content: this.$t('app.auto_543_9d579d33'),
        },
      ],
      rules: {
        textWeight: [{ required: true, validator: kon, trigger: 'blur' }],
      },
      marker: [this.$t('app.auto_544_a5ef145f'), this.$t('app.auto_545_f6c84cd4'), 'NEW', 'HOT'],
      dragOptions: {
        animation: 200,
      },
      optionsType: [
        {
          type: '10',
          name: this.$t('app.auto_546_466f0afa'),
        },
        {
          type: '11',
          name: this.$t('app.auto_547_94cf8395'),
        },
      ], // 选择跳转类型
      options: [], //后端返回的列表提供下拉选择
      emptyText: '',
    }
  },
  created() {},
  methods: {
    selectType(index) {
      // 每次切换类型之前 清空之前选中跳转
      this.datas.imageList[index].http = {}
      // 清空 options
      this.options = []
    },
    // 提交
    uploadInformation(res) {
      this.datas.imageList.push({
        src: res,
        text: this.$t('app.auto_548_26ce1760'),
        http: {},
        type: '1',
      })
    },

    /* 删除图片 */
    deleteimg(index) {
      this.datas.imageList.splice(index, 1)
    },
  },
  computed: {
    // eslint-disable-next-line vue/return-in-computed-property
    styleText() {
      if (this.datas.commodityType === 0) return this.$t('app.auto_549_54c8c4c1')
      if (this.datas.commodityType === 1) return this.$t('app.auto_550_c251ad87')
      if (this.datas.commodityType === 2) return this.$t('app.auto_551_9467c276')
      if (this.datas.commodityType === 3) return this.$t('app.auto_552_72134306')
      if (this.datas.commodityType === 4) return this.$t('app.auto_553_47503a5b')
      if (this.datas.commodityType === 5) return this.$t('app.auto_554_e61f75d1')
    },
  },
}
</script>

<style scoped lang="scss">
.storenotecardstyle {
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  padding: 0 10px 20px;
  box-sizing: border-box;

  /* 标题 */
  h2 {
    padding: 24px 16px 24px 0;
    margin-bottom: 15px;
    border-bottom: 1px solid #f2f4f6;
    font-size: 18px;
    font-weight: 600;
    color: #323233;
  }

  .lef {
    ::v-deep .el-form-item__label {
      text-align: left;
    }
  }

  /* 图片字 */
  .imgText1 {
    width: 100%;
    display: flex;
    box-sizing: border-box;
    justify-content: space-between;
    .fir-sele.el-select {
      width: 40%;
    }
  }

  /* 列表样式 */
  .commodityType {
    display: flex;
    justify-content: space-around;
    align-items: center;
    span {
      display: inline-block;
      width: 58px;
      height: 32px;
      text-align: center;
      line-height: 32px;
      background: #fff;
      border: 1px solid #ebedf0;
      color: #979797;
      margin: 0 1px;
      cursor: pointer;
      transition: all 0.5s;

      &:hover {
        border: 1px solid #155bd4;
        color: #155bd4;
      }

      &.active {
        border: 1px solid #155bd4;
        background-color: #e0edff;
        color: #155bd4;
      }
    }
  }

  /* 卡片样式 */
  .moditystyle {
    font-size: 12px;
    width: 100%;
    display: flex;
    span {
      width: 86px;
      height: 32px;
      display: inline-block;
      text-align: center;
      line-height: 32px;
      cursor: pointer;
      border: 1px solid #ebedf0;
      &.active {
        border: 1px solid #155bd4;
        background-color: #e0edff;
        color: #155bd4;
      }
    }
  }

  /* 位置 */
  .weiz {
    text-align: right;
    i {
      padding: 5px 14px;
      margin-left: 10px;
      border-radius: 0;
      border: 1px solid #ebedf0;
      font-size: 20px;
      font-weight: 500;
      cursor: pointer;

      &:last-child {
        font-size: 22px;
      }

      &.active {
        color: #155bd4;
        border: 1px solid #155bd4;
        background: #e0edff;
      }
    }
  }

  /* 单选框 */
  ::v-deep .radi1 {
    border-top: 1px solid #f7f8fa;
    border-bottom: 1px solid #f7f8fa;
    padding: 12px 0;
    .el-radio {
      margin: 10px 25px 7px 0;
    }
  }

  /* 卡片列表 */
  .imgBanner {
    padding: 6px 12px;
    margin: 16px 7px;
    border-radius: 2px;
    background-color: #fff;
    box-shadow: 0 0 4px 0 rgba(10, 42, 97, 0.2);
    display: flex;
    position: relative;

    /* 删除图标 */
    .el-icon-circle-close {
      position: absolute;
      right: -10px;
      top: -10px;
      cursor: pointer;
      font-size: 19px;
    }

    /* 图片 */
    .imag {
      width: 60px;
      height: 60px;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        display: inline-block;
      }
      span {
        background: rgba(0, 0, 0, 0.5);
        font-size: 12px;
        position: absolute;
        left: 0px;
        bottom: 0px;
        display: inline-block;
        width: 100%;
        text-align: center;
        color: #fff;
        height: 20px;
        line-height: 20px;
      }
    }

    /* 图片字 */
    .imgText {
      width: 80%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding-left: 20px;
      justify-content: space-between;
      /* 图片字 */
      .imgTextChild {
        width: 100%;
        display: flex;
        box-sizing: border-box;
        justify-content: space-between;
        .fir-sele.el-select {
          width: 40%;
        }
      }
    }
  }

  /* 上传图片按钮 */
  .uploadImg {
    width: 345px;
    height: 40px;
    margin-top: 20px;
  }

  // 上传弹框内容部分
  ::v-deep .uploadIMG .el-dialog__body {
    height: 280px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    justify-content: center;
  }

  .disable {
    ::v-deep .el-upload {
      display: none !important;
    }
  }

  .tit {
    ::v-deep .el-input__inner {
      text-align: center;
    }
  }
}
</style>
